import {
    Text1,
    Text4,
    Text2,
    Text3,
    Divider,
    BoxedRow,
    skinVars,
    IconChevronLeftRegular,
    NavigationBar,
    ThemeVariant,
    useWindowSize,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import imageMobile from '../../../../assets/images/mobile_rentings.png';
import { useTranslation } from 'react-i18next';
import './index.scss';
import { ButtonLink } from '@telefonica/mistica';
import dayjs from 'dayjs';
import { getCatalogImage } from '../../../../services/ProductService';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import { useNavigate } from 'react-router-dom';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';
import { useDevicesContext } from '../../../../context/devices-context/DevicesContext';

const DevicesDetails: React.FC = () => {
    const { t } = useTranslation();
    const { device } = useDevicesContext();
    const [image, setImage] = useState<string>();
    const { trackingScreenView } = new TrackingEvents();
    const size = useWindowSize();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const getDeviceLiteral = (): string => {
        if (!device) return '';
        switch (device.deviceType) {
            case 'FREE_DEVICE':
                return t('freeDevice');
            case 'R2R_ESTRENA_SUPPORT':
                return t('deviceIncludedEstrena');
            case 'R2R_SUPPORT':
                return t('includeDevice');
            case 'R2R_ESTRENA':
                return t('deviceEstrena');
            default:
                return t('device');
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        getCatalogImage(device.imageId)
            .then((resp) => setImage(`data:image/jpg;base64,${resp.data.content}`))
            .catch(() => setImage(imageMobile))
            .finally(() => setIsLoading(false));
    }, []);

    return (
        <div>
            {device && !isLoading && (
                <>
                    <div
                        className='devices'
                        style={{ borderBottom: size.width >= 1024 ? `1px solid ${skinVars.colors.divider}` : 'none' }}
                    >
                        {!(isWebviewAndroid || isWebviewIOS) && (
                            <>
                                <div className='devices-header-navigationBar'>
                                    <NavigationBar
                                        onBack={() => {
                                            navigate(-1);
                                        }}
                                        title={t('devices')}
                                    />
                                </div>
                                <div className='devices-header-return'>
                                    <div
                                        className='devices-header-return-cursor'
                                        onClick={() => {
                                            navigate(-1);
                                        }}
                                    >
                                        <div className='devices-header-return-icon'>
                                            <IconChevronLeftRegular size={20} />
                                        </div>
                                        <Text2 medium>{t('returnResponsive')}</Text2>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className='devices-header-breadcrumbs'>
                            <ThemeVariant>
                                <BreadCrumbsWrapper
                                    title={t('devicesSection')}
                                    breadcrumbs={[{ title: t('breadcrumbsHome'), url: '/home' }]}
                                />
                            </ThemeVariant>
                        </div>
                    </div>
                    <div className='devices-page'>
                        <div className='devices-page__firstBox'>
                            <div className='devices-page__firstBox__text1'>
                                <Text1 medium color={skinVars.colors.textSecondary}>
                                    {t('youDevice')}
                                </Text1>
                            </div>
                            <div className='devices-page__firstBox__wrapper'>
                                <BoxedRow
                                    title=''
                                    extra={
                                        <div className='devices-page__firstBox__wrapper__extra'>
                                            <div className='devices-page__firstBox__wrapper__extra__imgAndContent'>
                                                <div className='devices-page__firstBox__wrapper__extra__imgAndContent__img'>
                                                    <img height='167' src={image} />
                                                </div>
                                                <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content'>
                                                    <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__text'>
                                                        <Text4 regular color={skinVars.colors.textPrimary}>
                                                            {device.name}
                                                        </Text4>
                                                    </div>
                                                    <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__text-typeDevice'>
                                                        <Text3 regular color={skinVars.colors.textSecondary}>
                                                            {getDeviceLiteral()}
                                                        </Text3>
                                                    </div>
                                                    <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__contratacion'>
                                                        <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__contratacion__text'>
                                                            <Text1 medium color={skinVars.colors.textSecondary}>
                                                                {device.endDate
                                                                    ? t('devicesHiringText')
                                                                    : t('buyDevice')}
                                                            </Text1>
                                                        </div>
                                                        <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__contratacion__wrapper'>
                                                            <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__contratacion__wrapper__inicio'>
                                                                <Text3 regular color={skinVars.colors.textPrimary}>
                                                                    {device.endDate
                                                                        ? t('devicesInitialText')
                                                                        : t('dateDeviceBuy')}
                                                                </Text3>
                                                                <Text2 regular color={skinVars.colors.textSecondary}>
                                                                    {dayjs(device.startDate).format('DD/MM/YYYY')}
                                                                </Text2>
                                                            </div>
                                                            {device.endDate && (
                                                                <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__contratacion__wrapper__fin'>
                                                                    <Text3 regular color={skinVars.colors.textPrimary}>
                                                                        {t('devicesEndText')}
                                                                    </Text3>
                                                                    <Text2
                                                                        regular
                                                                        color={skinVars.colors.textSecondary}
                                                                    >
                                                                        {dayjs(device.endDate).format('DD/MM/YYYY')}
                                                                    </Text2>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__contratacion__divider'>
                                                        <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__contratacion__divider-divider1'>
                                                            <Divider></Divider>
                                                        </div>
                                                        {device.endDate && (
                                                            <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__contratacion__divider-divider2'>
                                                                <Divider></Divider>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__cuotas'>
                                                        <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__cuotas__text'>
                                                            <Text1 medium color={skinVars.colors.textSecondary}>
                                                                {device.endDate
                                                                    ? t('devicesFeeText')
                                                                    : t('deviceDetailPrice')}
                                                            </Text1>
                                                        </div>
                                                        <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__cuotas__wrapper'>
                                                            <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__cuotas__wrapper__precio'>
                                                                <Text3 regular color={skinVars.colors.textPrimary}>
                                                                    {device.endDate
                                                                        ? t('devicesMensualPriceText')
                                                                        : t('deviceBuyAllPrice')}
                                                                </Text3>
                                                                <Text2 regular color={skinVars.colors.textSecondary}>
                                                                    {device?.price?.toFixed(2).toLocaleString() + '€'}
                                                                </Text2>
                                                            </div>
                                                            {device.endDate && (
                                                                <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__cuotas__wrapper__cuotas'>
                                                                    <Text3 regular color={skinVars.colors.textPrimary}>
                                                                        {t('devicesNumberFeeText')}
                                                                    </Text3>
                                                                    <Text2
                                                                        regular
                                                                        color={skinVars.colors.textSecondary}
                                                                    >
                                                                        {device.months}
                                                                    </Text2>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className='devices-page__firstBox__wrapper__extra__imgAndContent__content__cuotas__divider'>
                                                            <Divider></Divider>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='devices-page__firstBox__wrapper__extra__divider'>
                                                <Divider></Divider>
                                            </div>
                                            <div className='devices-page__firstBox__wrapper__extra__button'>
                                                <ButtonLink
                                                    onPress={() => {
                                                        window.open(
                                                            'https://dlvt1u0vrr0ux.cloudfront.net/media/public/condiciones_generales_dispositivos_o2.pdf',
                                                            '_blank',
                                                        );
                                                    }}
                                                >
                                                    {t('devicesButtonConditions')}
                                                </ButtonLink>
                                            </div>
                                        </div>
                                    }
                                ></BoxedRow>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default DevicesDetails;
